'use client'

import { useEffect } from 'react'
import { AlertCircle } from 'lucide-react'

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    useEffect(() => {
        // Log the error to an error reporting service
        console.error('Captured Runtime App Error:', error)
    }, [error])

    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
            <div className="bg-red-50 text-red-600 p-4 rounded-full mb-6">
                <AlertCircle className="w-12 h-12" />
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Oops! Algo deu errado.</h2>
            <p className="text-gray-600 max-w-md mx-auto mb-8 text-lg">
                Encontramos uma instabilidade temporária. Nossa equipe já foi notificada caso o problema persista.
            </p>
            <button
                onClick={() => reset()}
                className="bg-gray-900 hover:bg-gray-800 text-white font-semibold py-3 px-8 rounded-xl transition-all shadow-md hover:shadow-lg active:scale-95"
            >
                Tentar Novamente
            </button>
        </div>
    )
}
